import { render, staticRenderFns } from "./SdAllocationHistory.vue?vue&type=template&id=060f152e&scoped=true"
import script from "./SdAllocationHistory.vue?vue&type=script&lang=js"
export * from "./SdAllocationHistory.vue?vue&type=script&lang=js"
import style0 from "./SdAllocationHistory.vue?vue&type=style&index=0&id=060f152e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f152e",
  null
  
)

export default component.exports